import React, { Component } from "react";
import $ from "jquery";
import { getStateDetailsNew, finalMeassegeSend, dataUpdate, enquiryForm } from '../service'
import ReCAPTCHA from "react-google-recaptcha";
import DeviceDetector from "device-detector-js";
import axios from 'axios'
import moment from 'moment';
import { cityNameGlobal } from "../components/GlobalCity.js";
const deviceDetector = new DeviceDetector();
const userAgent = "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.81 Safari/537.36";
const device = deviceDetector.parse(userAgent);
let flag = false;
// var cityName = window.location.host.split('.')[0]
// var cityName ="bangalore"
const city = window?.location?.pathname?.split?.('/')?.pop?.();
const cityName = cityNameGlobal ? cityNameGlobal : city
class FormData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      courseList: [],
      siteList: [],
      psource: "",
      ssource: "",
      ip: "",
      cityselectedPhoneNumber: "",
      CourseOfCity: [],
      captchaValue: "1",
    }
    this.onChangeCaptcha = this.onChangeCaptcha.bind(this)
    this.onExpiredCaptcha = this.onExpiredCaptcha.bind(this)
  }
  componentDidMount() {
    $(function () {
      function rescaleCaptcha() {
        var width = $('.g-recaptcha').parent().width();
        var scale;
        if (width < 302) {
          scale = width / 302;
        } else {
          scale = 1.0;
        }
        $('.g-recaptcha').css('transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('-webkit-transform', 'scale(' + scale + ')');
        $('.g-recaptcha').css('transform-origin', '0 0');
        $('.g-recaptcha').css('-webkit-transform-origin', '0 0');
      }
      rescaleCaptcha();
      $(window).resize(function () { rescaleCaptcha(); });
    });
    $("#submitbutton").attr('disabled', true);
    localStorage.removeItem('EnqNo')
    const queryParams = new URLSearchParams(window.location.search)
    const psource = queryParams.get("psource")
    const ssource = queryParams.get("ssource")
    this.setState({
      psource: psource,
      ssource: ssource
    });
    $("#pleaseWait").hide();
    getStateDetailsNew().then((data) => {
      this.setState({
        listState: data.result.stateData
      });
    });
    this.getData()
    const postData = {
      "cityName": cityName,
      "functionName": "courseListWithCity"
    }
    dataUpdate(postData).then((data) => {
      if (data.data.result.courses.length > 0) {
        this.setState({
          courseList: data.data.result.courses,
        });
      }
    });
  }
  getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    this.setState({
      ip: res.data.IPv4
    });
  }
  formSubmit(e) {
    $("#submitbutton").hide()
    $("#pleaseWait").show();
    e.preventDefault();
    localStorage.setItem('Name', $("#txtCounsellingName").val())
    localStorage.setItem('PhoneNumber', $("#txtCounsellingMobile").val())
    localStorage.setItem('leadEmail', $("#txtCounsellingEmail").val())
    localStorage.setItem('leadCourse', $("#cmbCounsellingCourse").find(":selected").text())
    let psource = this.state.psource
    let ssource = this.state.ssource
    let centre = $("#councellingCentre").val();
    let name = $("#txtCounsellingName").val();
    let email = $("#txtCounsellingEmail").val();
    let mobileNo = $("#txtCounsellingMobile").val();
    let qualification = $("#councellingHighestQualification").val()
    let courseId = $("#cmbCounsellingCourse").val();
    let courseName = $("#cmbCounsellingCourse").find(":selected").text()
    let siteId = centre;
    let stateId = $("#councellingState").val();
    let cityId = $("#councellingCity").val();
    let currentUrl = window.location.href;
    let ipAdd = "";
    let saveId = "";
    var contactPost = {
      name: name,
      emailId: email,
      mobileNumber: mobileNo,
      courseId: courseId,
      stateId: "0",
      cityId: "0",
      centerId: siteId,
      reason: "",
      isCampaign: true,
      ipAddress: this.state.ip,
      sSource: (ssource !== null && ssource !== "null" && ssource !== "") ? ssource : this.props.fromPage,
      pSource: (psource !== null && psource !== "null" && psource !== "") ? psource : (device.device.type == "desktop" ? "Website" : "Mobile Website"),
      pageUrl: currentUrl,
      browser: device.client.name,
      devices: device.device.type,
      submission_date: Date.parse(moment(new Date()).format('YYYY/MM/DD hh:mm A')),
      functionName: "saveContactUs",
      courseName: courseName,
      sub_domain:cityName
    }
    dataUpdate(contactPost).then((data) => {
      console.log("dataaaaaa", data)
      saveId = data.data.result.id
      this.formSubmitFunction(name, email, mobileNo, stateId, siteId, courseId, ipAdd, currentUrl, qualification, cityId, saveId)
    });
  }
  formSubmitFunction(name, email, mobileNo, stateId, siteId, courseId, ipAdd, currentUrl, qualification, cityId, saveId) {
    let psource = this.state.psource
    let ssource = this.state.ssource
    var postData = {
      // "I_Brand_ID": brandId,
      "I_Brand_ID": "111",
      "S_First_Name": name,
      "S_Last_Name": null,
      "S_Email_ID": email,
      "S_Mobile_No": mobileNo,
      "S_Phone_No": null,
      "I_Pref_State_ID": "0",
      "I_Pref_Center_ID": siteId,
      "I_CourseEnquiryMaster_ID": courseId,
      "S_Comments": null,
      "S_CurrentlyDoing": "",
      // "S_Brand_Code": brandCode,
      "S_Brand_Code": "LAPA",
      "S_Ip_Address_Location": this.state.ip,
      // "S_Ip_Address_Location": "3.6.11.84",
      "S_Form_Name": null,
      "S_S_Source": (ssource !== null && ssource !== "null" && ssource !== "") ? ssource : this.props.fromPage,
      "S_P_Source": (psource !== null && psource !== "null" && psource !== "") ? psource : (device.device.type == "desktop" ? "Website" : "Mobile Website"),
      "S_Network": null,
      "S_Creative": null,
      "S_Keyword": null,
      "S_Placement": null,
      "S_Adposition": null,
      "S_MatchType": null,
      "S_accid": null,
      "S_Page_URL": currentUrl,
      // "S_Page_URL": "http://3.6.11.84/",
      "S_Pages_Visited": "",
      "I_City_ID": "0"
    }
    enquiryForm(postData).then((data) => {
      try {
        localStorage.setItem("userMobileNo", mobileNo)
        var parseResult = JSON.parse(data.data.body)
        var enqNo = parseResult.EnqNo
        if (parseResult.result == "Success") {
          enqNo = ((enqNo === "" || enqNo === "null" || enqNo === null) ? 'NA' : enqNo)
          localStorage.setItem('EnqNo', enqNo);
          var postData = {
            "functionName": "saveEnquireNumber",
            "id": saveId,
            "enquireNumber": enqNo
          }
          console.log("mmmmmmmmmmmmmmm", postData)
          dataUpdate(postData).then((data) => {
          });
          window.location.href = '/thankyou'
        }
      } catch (err) {
        console.log('error.......', err);
        localStorage.setItem('EnqNo', 'NA');
        window.location.href = '/thankyou'
      }
    })
  }
  nameValidate() {
    let name = $("#txtCounsellingName").val();
    var charactersName = /^[a-zA-Z\s]*$/;
    if (!name || charactersName.test(name) === false) {
      $("#txtCounsellingName").focus()
      $("#txtCounsellingNameError").show();
    }
    else {
      $("#txtCounsellingNameError").hide();
    }
    this.handleonChange()
  }
  mobileValidate() {
    let name = $("#txtCounsellingMobile").val();
    var charactersName = /^[5-9][0-9]{9}$/;
    if (!name || charactersName.test(name) === false) {
      $("#txtCounsellingMobile").focus()
      $("#txtCounsellingMobileError").show();
    }
    else {
      $("#txtCounsellingMobileError").hide();
    }
    this.handleonChange()
  }
  emailValidate() {
    let name = $("#txtCounsellingEmail").val();
    var charactersEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!name || charactersEmail.test(name) === false) {
      $("#txtCounsellingEmail").focus()
      $("#txtCounsellingEmailError").show();
    }
    else {
      $("#txtCounsellingEmailError").hide();
    }
    this.handleonChange()
  }
  handleonChangeCourse(e) {
    var value = e.target.value;
    if (value === "0") {
      $("#SelectCourse").show();
      this.setState({
        CourseOfCity: [],
      });
    }
    else {
      $("#SelectCourse").hide();
      const postData = {
        "functionName": "campaignCentres",
        "cityName": cityName,
        "courseId": $("#cmbCounsellingCourse").val()
      }
      dataUpdate(postData).then((data) => {
        if (data.data.result.centres.length > 0) {
          this.setState({
            CourseOfCity: data.data.result.centres,
          });
        }
      })
    }
    this.handleonChange()
  }
  handleonChangeCentre(e) {
    var valuesss = e.target.value;
    if (valuesss == "0" || valuesss === "null" || valuesss === null) {
      $("#SelectCityError").show();
    }
    else {
      let obj = this.state.CourseOfCity.find(obj => obj.centreId.toString() === valuesss);
      localStorage.setItem('callMeBackNumber', obj.callMeBackNumber)
      localStorage.setItem('callNowNumber', obj.callNowNumber)
      localStorage.setItem('PhoneNumberCenter', obj.mobileNumber)
      localStorage.setItem('CenterChoosed', obj.centreName)
      localStorage.setItem('EmailIdCenter', obj.centerEmailId)
      $("#SelectCityError").hide();
    }
    this.handleonChange()
  }
  onChangeCaptcha(value) {
    console.log("onChangeCaptcha: ", value);
    this.setState({
      captchaValue: '1'
    }, () => {
      this.handleonChange()
    })
  }
  onExpiredCaptcha(value) {
    console.log("onExpiredCaptcha: ", value);
    this.setState({
      captchaValue: ""
    }, () => {
      this.handleonChange()
    })
  }
  handleonChange() {
    $("#reCaptchaerror").hide();
    $("#submitbutton").attr('disabled', true);
    let flag = true
    let centre = $("#councellingCentre").val();
    let name = $("#txtCounsellingName").val();
    let email = $("#txtCounsellingEmail").val();
    let mobileNo = $("#txtCounsellingMobile").val();
    let courseId = $("#cmbCounsellingCourse").val();
    var charactersName = /^[a-zA-Z\s]*$/;
    var mobile = /^\d{10}$/;
    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!$("#txtCounsellingName").val() || charactersName.test(name) === false) {
      flag = false
    }
    if (!mobileNo || mobile.test(mobileNo) === false) {
      flag = false
    }
    if (mobileNo.length != 10 && (!$("#txtCounsellingMobile").val().match(/^[0-9]{10}$/))) {
      flag = false
    }
    if (!email) {
      flag = false
    }
    if (characters.test(email) == false) {
      flag = false
    }
    if (courseId == "0") {
      flag = false
    }
    if (centre == "0" || centre == "null" || centre == null) {
      flag = false
    }
    if ((this.state.captchaValue === "") && (flag === true)) {
      $("#reCaptchaerror").show();
      flag = false
    }
    if (flag === true) {
      $("#submitbutton").attr('disabled', false);
    }
  }
  showalert() {
    let validateTxt = document.getElementById("validate-txt");
    validateTxt.style.display = 'block';
    
    // After 5 seconds, hide the content element again
    setTimeout(function() {
        validateTxt.style.display = 'none';
    }, 5000); // 5000 milliseconds = 5 seconds        
  }
  render() {
    return (
      <div className="formWrapper">
        <div className="col-xs-12 formSection">
          {" "}
          <a name="topformlink"></a>
          <div className="studenEnquiry" data-aos="fade-up">
            <h2 className="text-center enquiryText">
              ENQUIRY FORM <div className="fromSpan">for Free Career Counselling</div>
            </h2>
            <form id="formCareer">
              <div className="form-group">
                <input
                  onKeyUp={() => this.nameValidate()} onChange={() => this.handleonChange()}
                  id="txtCounsellingName"
                  placeholder="Enter Your Name*"
                  className="form-controls"
                />
                <div id='PleaseEnterYourNameError' className="error">
                  Please enter your name
                </div>
                <div id='txtCounsellingNameError' className="error">
                  Please enter a valid name (A-Z, a-z)
                </div>
              </div>
              <div className="form-group">
                <input
                  id="txtCounsellingMobile"
                  placeholder="Mobile No *"
                  autoComplete="off" onKeyUp={() => this.mobileValidate()} onChange={() => this.handleonChange()} maxlength="10"
                  className="form-controls"
                />
                <div class="error" id='enterYourMobileNumberError'>Please enter your mobile number</div>
                <div class="error" id='txtCounsellingMobileError'>Please enter a valid mobile number</div>
              </div>
              <div className="form-group">
                <input
                  id='txtCounsellingEmail' autoComplete="off" onKeyUp={() => this.emailValidate()} onChange={() => this.handleonChange()}
                  placeholder="Enter Email Id*"
                  className="form-controls"
                />
                <div class="error" id="enterYourEmailError">Please enter your email Id</div>
                <div class="error" id='txtCounsellingEmailError'>Please enter a valid email Id</div>
              </div>
              <div className="form-group">
                <select name="ddl_courses" id="cmbCounsellingCourse" onChange={(e) => this.handleonChangeCourse(e)} className="form-controls">
                  <option value={0}>Select Course interested in *</option>
                  {this.state.courseList.map((course, k) => (
                    <option key={k} value={course.courseId}>{course.courseName}</option>
                  ))}
                </select>
                <div id='SelectCourse' className="error">
                  Select Course interested in
                </div>{" "}
              </div>
              <div className="form-group">
                <select name="ddlCenter" id="councellingCentre" onChange={(e) => this.handleonChangeCentre(e)} className="form-controls">
                  <option value="0">Select Centres</option>
                  {this.state.CourseOfCity.map((listCity, t) => (
                    <option value={listCity.centreId} key={t} >{listCity.centreName}</option>
                  ))}
                </select>
                <div id='SelectCityError' className="error">
                  Select Center
                </div>
              </div>
              <div className="afterverification">
                <div className="captcha-divv g-recaptcha">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={(e) => this.onChangeCaptcha(e)}
                    onExpired={(e) => this.onExpiredCaptcha(e)}
                  />
                  <div class="error" id='reCaptchaerror'>Please select Recaptcha checkbox.</div>
                </div>
                <p className="text-blacks">
                  <small>
                    <em>
                      By clicking on Submit, I allow Lakmé Academy Powered by
                      Aptech to contact me, and use &amp; share my personal data
                      as per the{" "}
                      <a
                        href="https://www.lakme-academy.com/privacy-policy"
                        title="Privacy Policy"
                        target="_blank"
                      >
                        Privacy Policy.
                      </a>
                    </em>
                  </small>
                </p>
                <div className="btn-interest">
                  <button
                    id="submitbutton" onClick={(e) => this.formSubmit(e)}
                    className="bur btn submit button dark"
                  >
                    Submit
                  </button>
                  <button id='pleaseWait'
                    className="bur btn submit button dark"
                    disabled
                  >
                    PLEASE WAIT....
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="thank-btn">
          <p className="validate-txt" id="validate-txt">Please fill in the above details to connect with our counsellor</p>
            <a class="custom-btn btn btn-call-enquiry" href="javascript:void(0);" onClick={() => this.showalert()} >
              <span>
                <svg width="20" height="20" viewBox="0 0 32 32" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.4502 20.93C23.1715 20.6504 22.8403 20.4284 22.4756 20.277C22.111 20.1256 21.72 20.0477 21.3252 20.0477C20.9303 20.0477 20.5394 20.1256 20.1747 20.277C19.8101 20.4284 19.4789 20.6504 19.2002 20.93L17.7502 22.38C16.1176 21.3439 14.605 20.1298 13.2402 18.76C11.8733 17.3926 10.6595 15.8804 9.62016 14.25L11.0702 12.8C11.3498 12.5213 11.5718 12.1901 11.7232 11.8255C11.8746 11.4608 11.9525 11.0699 11.9525 10.675C11.9525 10.2802 11.8746 9.88923 11.7232 9.52457C11.5718 9.15992 11.3498 8.82874 11.0702 8.55003L8.24016 5.73003C7.96539 5.44942 7.63701 5.22692 7.27453 5.07575C6.91206 4.92457 6.52289 4.84781 6.13016 4.85003C5.73464 4.84906 5.34284 4.92631 4.97729 5.07734C4.61174 5.22836 4.27966 5.45018 4.00016 5.73003L2.64016 7.08003C1.99193 7.777 1.50813 8.61038 1.22433 9.5189C0.940521 10.4274 0.863923 11.388 1.00016 12.33C1.32016 16.08 3.78016 20.59 7.57016 24.39C11.3602 28.19 15.9202 30.64 19.6702 31C19.95 31.015 20.2304 31.015 20.5102 31C21.3174 31.0339 22.1233 30.9063 22.8805 30.6247C23.6378 30.3431 24.3312 29.9131 24.9202 29.36L26.2702 28C26.55 27.7205 26.7718 27.3885 26.9229 27.0229C27.0739 26.6574 27.1511 26.2655 27.1502 25.87C27.1524 25.4773 27.0756 25.0881 26.9244 24.7257C26.7733 24.3632 26.5508 24.0348 26.2702 23.76L23.4502 20.93ZM24.8602 26.59L23.5002 27.94C22.9973 28.3591 22.4103 28.6653 21.7788 28.8378C21.1474 29.0103 20.4863 29.0452 19.8402 28.94C16.5902 28.66 12.4502 26.36 9.03016 22.94C5.61016 19.52 3.31016 15.41 3.00016 12.16C2.89232 11.5139 2.92588 10.8522 3.09852 10.2203C3.27116 9.58843 3.57878 9.00152 4.00016 8.50003L5.41016 7.14003C5.5036 7.04735 5.61442 6.97402 5.73626 6.92426C5.85809 6.87449 5.98856 6.84927 6.12016 6.85003C6.25177 6.84927 6.38223 6.87449 6.50407 6.92426C6.62591 6.97402 6.73672 7.04735 6.83016 7.14003L9.66016 10C9.84641 10.1874 9.95095 10.4408 9.95095 10.705C9.95095 10.9692 9.84641 11.2227 9.66016 11.41L7.66016 13.41C7.50366 13.5658 7.40309 13.7689 7.37415 13.9878C7.34521 14.2067 7.38952 14.429 7.50016 14.62C8.69755 16.6585 10.1529 18.534 11.8302 20.2C13.4962 21.8773 15.3717 23.3326 17.4102 24.53C17.6012 24.6407 17.8235 24.685 18.0424 24.656C18.2613 24.6271 18.4644 24.5265 18.6202 24.37L20.6202 22.37C20.8075 22.1838 21.061 22.0792 21.3252 22.0792C21.5893 22.0792 21.8428 22.1838 22.0302 22.37L24.8602 25.2C24.9528 25.2935 25.0262 25.4043 25.0759 25.5261C25.1257 25.648 25.1509 25.7784 25.1502 25.91C25.1439 26.1654 25.0401 26.4087 24.8602 26.59ZM26.6002 5.39003C25.2104 3.995 23.5583 2.88887 21.739 2.13541C19.9197 1.38196 17.9693 0.996078 16.0002 1.00003C15.7349 1.00003 15.4806 1.10539 15.2931 1.29292C15.1055 1.48046 15.0002 1.73481 15.0002 2.00003C15.0002 2.26525 15.1055 2.5196 15.2931 2.70714C15.4806 2.89467 15.7349 3.00003 16.0002 3.00003C17.7166 2.99997 19.4161 3.33983 21.0006 4.00001C22.585 4.66019 24.0231 5.62761 25.2317 6.84645C26.4403 8.06529 27.3955 9.51141 28.0423 11.1014C28.6892 12.6913 29.0147 14.3936 29.0002 16.11C29.0002 16.3752 29.1055 16.6296 29.2931 16.8171C29.4806 17.0047 29.7349 17.11 30.0002 17.11C30.2654 17.11 30.5197 17.0047 30.7073 16.8171C30.8948 16.6296 31.0002 16.3752 31.0002 16.11C31.0193 14.12 30.6399 12.1462 29.8842 10.3051C29.1285 8.46399 28.0119 6.79279 26.6002 5.39003Z" fill="white"/>
                  <path d="M20.9097 11.1103C21.4772 11.6744 21.9262 12.3463 22.2301 13.0865C22.5341 13.8267 22.687 14.6202 22.6797 15.4203C22.6797 15.6855 22.785 15.9399 22.9726 16.1274C23.1601 16.315 23.4145 16.4203 23.6797 16.4203C23.9449 16.4203 24.1993 16.315 24.3868 16.1274C24.5743 15.9399 24.6797 15.6855 24.6797 15.4203C24.6929 14.3614 24.4958 13.3103 24.0997 12.3281C23.7036 11.3459 23.1164 10.4522 22.3722 9.6987C21.628 8.94521 20.7416 8.34698 19.7644 7.9387C18.7872 7.53042 17.7387 7.32023 16.6797 7.32031C16.4145 7.32031 16.1601 7.42567 15.9726 7.61321C15.785 7.80074 15.6797 8.0551 15.6797 8.32031C15.6797 8.58553 15.785 8.83988 15.9726 9.02742C16.1601 9.21496 16.4145 9.32031 16.6797 9.32031C17.4678 9.32625 18.247 9.48739 18.9728 9.79452C19.6985 10.1017 20.3567 10.5488 20.9097 11.1103Z" fill="white"/>
                  </svg>
              </span> Call for Enquiry 
            </a> 
            <a class="custom-btn btn btn-whatapp" href="javascript:void(0);" onClick={() => this.showalert()} >
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-whatsapp" viewBox="0 0 16 16">
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                </svg>
              </span> WhatsApp 
            </a>
          </div>
        </div>
      </div>
    );
  }
}
export default FormData;
